export const hideGnav = (options = { showLogo: false }) => {
  if (options.showLogo) {
    // Hide everything keep logo
    const gnavWrapper = document.querySelector('#vzw-gn .nav-wrapper');

    if (gnavWrapper) {
      gnavWrapper.style.display = 'none';
    }

    const gnav20Wrapper = document.querySelector('#vz-gh20 .gnav20-main .gnav20-gnav');
    if (gnav20Wrapper) {
      gnav20Wrapper.style.display = 'none';
    }
  } else {
    const gnav = document.getElementById('vzw-gn');
    if (gnav) {
      gnav.style.display = 'none';
    }

    const gnav20 = document.getElementById('vz-gh20');
    if (gnav20) {
      gnav20.style.display = 'none';
    }
  }
};

export const hideFooter = (options = { persist: false }) => {
  // Hide Footer

  if (options.persist) {
    // Not shown automatically with first call
    const globalFooter = document.getElementById('vzw-gf');
    if (globalFooter) {
      globalFooter.style.display = 'none';
    }

    const newGlobalFooter = document.getElementById('vz-gf20');
    if (newGlobalFooter) {
      newGlobalFooter.style.display = 'none';
    }
  } else {
    // Shown automatically once first ajax call is completed
    const globalFooter = document.getElementById('vzw-gf');
    if (globalFooter) {
      globalFooter.classList.add('is-hidden');
    }

    const newGlobalFooter = document.getElementById('vz-gf20');
    if (newGlobalFooter) {
      newGlobalFooter.classList.add('is-hidden');
    }
  }
};
